import { Subscription } from 'rxjs';
import { InteractivityEditorService } from '../../services/interactivity-editor.service';
import { InteractivityMediaService } from './../../services/interactivity-media.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MediaclipAsset } from 'app/interfaces/mediaclip';


@Component({
	selector: 'player-bar',
	templateUrl: './player-bar.component.html',
	styleUrls: ['./player-bar.component.scss']
})

export class PlayerBarComponent implements OnInit, OnDestroy {
	currentTime: string;
	duration: string;
	playing: boolean;
	muted: boolean;

	private subscriptions: Subscription;

	constructor(
		private interactivityMediaService: InteractivityMediaService,
		private interactivityEditorService: InteractivityEditorService
	) {

		this.currentTime = '00:00:00.00';
		this.duration = '00:00:00.00';
	}

	ngOnInit() {
		this.subscriptions = new Subscription();

		this.subscriptions.add(
			this.interactivityMediaService.currentTimeSubject.subscribe((time: number) => {
				this.currentTime = this.showDuration(time); // Math.round -> tmp dev
			})
		);

		this.subscriptions.add(
			this.interactivityMediaService.mutedSubject.subscribe((muted: boolean) => {
				this.muted = muted;
			})
		);

		this.subscriptions.add(
			this.interactivityEditorService.mediaclipAssetSubject.subscribe((mediaclipAsset: MediaclipAsset) => {
				if (mediaclipAsset && mediaclipAsset.exactlength) {
					this.duration = this.showDuration(parseInt(mediaclipAsset.exactlength, 10) / 1000);
				}
			})
		);

		this.subscriptions.add(
			this.interactivityMediaService.durationSubject.subscribe((duration: number) => {
				this.duration = this.showDuration(duration);
			})
		);

		this.subscriptions.add(
			this.interactivityMediaService.endedSubject.subscribe(() => {
				this.playing = false;
			})
		);
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	showDuration(time: number): string {
		if (time < 0) {
			return '00:00:00.00';
		}
		let timeDisplay = '';
		const remainder = time - Math.floor(time);
		time = Math.floor(time);

		const hour: number = Math.floor(time / 3600);
		timeDisplay += ('0' + hour).slice(-2) + ':';

		time -= hour * 3600;

		const minute: number = Math.floor(time / 60);
		timeDisplay += ('0' + minute).slice(-2) + ':';

		time -= minute * 60;

		timeDisplay += ('0' + time).slice(-2) + '.';

		timeDisplay += ('0' + (remainder * this.interactivityMediaService.fps).toFixed()).slice(-2);

		return timeDisplay;
	}

	showCurrentFrame(time: number): number {
		let currentTime = time;
		const currentIntTime = Math.floor(currentTime);
		const frame = currentTime - currentIntTime;

		currentTime = currentIntTime + (frame * this.interactivityMediaService.fps / 100);

		return currentTime;
	}

	previousFrame(): void {
		this.playing = false;
		this.interactivityMediaService.previousFrame();
	}

	nextFrame(): void {
		this.playing = false;
		this.interactivityMediaService.nextFrame();
	}

	previousSection(ev: any): void {
		this.playing = false;
		this.interactivityMediaService.previousSection();
	}

	nextSection(): void {
		this.playing = false;
		this.interactivityMediaService.nextSection();
	}

	toggleMute(): void {
		this.interactivityMediaService.toggleMute();
	}

	play(): void {
		this.interactivityMediaService.play();
		this.playing = true;
	}

	pause(): void {
		this.interactivityMediaService.pause();
		this.playing = false;
	}

}
